import { SpinningLoader } from '@/app_components/icons/SpinningLoader';

export const EventsLoader = () => {
  return (
    <div
      className='flex flex-col gap-sm h-full w-full max-lg:aspect-square lg:aspect-[12/5] md:aspect-[20/11] items-center justify-center mx-auto col-span-full'
      id='events-loader'
    >
      <SpinningLoader size={40} />
    </div>
  );
};
